export const state = {
  payments: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/payments/state.js